import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

function Well({
  id,
  isWellRectangle,
  background,
  color,
  containerColor,
  isSelected,
  wellText,
  border,
  borderSize,
  opacity,
  onMouseEnter,
  onMouseLeave,
  onClickWell,
  onMouseUp,
  onMouseDown,
  onTouchStart,
  isWellTrough,
  showWellText,
  disabled,
}) {
  let wellColor = '';
  if (Array.isArray(background)) {
    let sumVol = 0;
    for (let index = 0; index < background.length; index += 1) {
      const {volume} = background[index];
      sumVol += volume;
    }
    let lastPercentage = 0;
    wellColor = isWellRectangle ? 'linear-gradient(' : 'conic-gradient(';
    for (let index = 0; index < background.length; index += 1) {
      const wellConfig = background[index];
      const percentage = lastPercentage + (wellConfig.volume / sumVol) * 100;

      wellColor += `${wellConfig.background} ${lastPercentage}% ${percentage}%,`;
      lastPercentage = percentage;
    }
    wellColor = wellColor.substr(0, wellColor.length - 1);
    wellColor += ')';
  } else {
    wellColor = background;
  }

  return (
    <div className="labware-well-container" style={{backgroundColor: containerColor}}>
      {disabled ? (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <></>
      ) : (
        <div
          id={id}
          className={`labware-well labware-well-${isWellRectangle ? 'square' : 'circle'}
            ${isSelected ? 'selected' : ''}
            ${isWellTrough ? 'trough' : ''}
            `}
          style={{
            border: isSelected ? 'none' : `solid  ${borderSize}px ${border}`,
            background: wellColor,
            color,
            opacity,
          }}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          onMouseUp={onMouseUp}
          onMouseDown={onMouseDown}
          onTouchStart={onTouchStart}
          onClick={onClickWell}
        >
          <span className="well-text">{showWellText ? wellText : ''}</span>
        </div>
      )}
    </div>
  );
}

Well.propTypes = {
  id: PropTypes.string.isRequired,
  wellText: PropTypes.string,
  isWellRectangle: PropTypes.bool.isRequired,
  isWellTrough: PropTypes.bool.isRequired,
  background: PropTypes.any,
  color: PropTypes.string,
  border: PropTypes.string,
  borderSize: PropTypes.number,
  containerColor: PropTypes.string,
  opacity: PropTypes.number,
  isSelected: PropTypes.bool,
  showWellText: PropTypes.bool,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onClickWell: PropTypes.func,
  onMouseUp: PropTypes.func,
  onMouseDown: PropTypes.func,
  onTouchStart: PropTypes.func,
  disabled: PropTypes.bool,
};

Well.defaultProps = {
  isSelected: false,
  background: 'white',
  color: 'black',
  border: 'gray',
  borderSize: 1,
  containerColor: 'white',
  opacity: 1,
  wellText: '',
  showWellText: false,
  onMouseEnter: () => {},
  onMouseLeave: () => {},
  onClickWell: () => {},
  onMouseUp: () => {},
  onMouseDown: () => {},
  onTouchStart: () => {},
  disabled: false,
};

function areEqual(prevProps, nextProps) {
  return (
    prevProps.id === nextProps.id &&
    prevProps.wellText === nextProps.wellText &&
    prevProps.isWellRectangle === nextProps.isWellRectangle &&
    _.isEqual(prevProps.background, nextProps.background) &&
    prevProps.color === nextProps.color &&
    prevProps.border === nextProps.border &&
    prevProps.borderSize === nextProps.borderSize &&
    prevProps.opacity === nextProps.opacity &&
    prevProps.isSelected === nextProps.isSelected &&
    prevProps.containerColor === nextProps.containerColor &&
    prevProps.setWellSize === nextProps.setWellSize &&
    prevProps.isLabwareSelected === nextProps.isLabwareSelected &&
    prevProps.disabled === nextProps.disabled
  );
}

export default React.memo(Well, areEqual);
